module.exports = __webpack_public_path__ + "img/ps-6.47378585.jpg";